import { Pipe, PipeTransform } from '@angular/core'
import { Price } from '@naturalcycles/shared'

@Pipe({
  name: 'discount',
  standalone: false,
})
export class DiscountPipe implements PipeTransform {
  transform(price: Price, amount: number): Price {
    const newPrice = new Price(price)
    newPrice.discount = amount
    return newPrice
  }
}
